import { gql } from "@apollo/client";

export const SUBSCRIPTION_MESSENGER_COMMENT = gql`
  subscription OnMessengerCommentCreated($pageId: String!) {
    onMessengerCommentCreated(pageId: $pageId) {
      id
      psid
      name
      pageId
      fbLiveId
      postId
      commentId
      source
      direction
      message
      attachments {
        type
        url
      }
      status
      billDelivery {
        status
        orderGroup
      }
      createdAt
    }
  }
`;
